import React from 'react';
import {
	ColorPicker,
	FormGroup,
	FormControl,
    RichEditor
} from 'components';



const TermsSettings = ({shopContext }) => {

	const { state, setItem } = shopContext;
	const { checkout_condition_text } = state.settings


    return (
        
        <FormGroup label="Terms And Conditions" fullWidth>
            <FormControl
                label=" Terms and conditions checkbox" 
                info={`Add a checkbox that must be clicked before proceeding to checkout.
                Tip: You can also add url hyperlinks for terms and condition pages.`}
                withSwitch={[shopContext, 'settings.is_checkout_condition_active']}
            >
                <RichEditor
                    placeholder="I agree with terms & conditions"
                    BindToContext={[shopContext, 'settings.checkout_condition_text']}
                />
            </FormControl>
            <FormControl >
                <ColorPicker text="Checkbox color" BindToContext={[shopContext, 'settings.checkout_condition_color']} />
            </FormControl>
        </FormGroup>

    )
}


export  {TermsSettings};